import React from "react";
import logo from "../../assets/southzone-ils-footer-logo.png";
import text from "../../assets/southzone-ils-footer-text.png"
import { Link } from 'react-router-dom';
import "./footer.css";

const Footer = () => {

  const handlePhoneClick = (phoneNumber) => {
    if (navigator.userAgent.match(/Mobi/)) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      navigator.clipboard.writeText(phoneNumber);
      alert(`Phone number (${phoneNumber}) copied.`);
    }
  };

  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Rayakottai Main Road, Onnalvadi, Hosur - 635117</p>
          <p>
            Phone:{" "}
            <span
              className="clickable"
              onClick={() => handlePhoneClick("+91 9342943399")}
            >
              +91 9342943399
            </span>
          </p>
          <p>
            Email:{" "}
            <span
              className="clickable"
              onClick={() =>
                handleEmailClick("southzone.ils@gmail.com")
              }
            >
              southzone.ils@gmail.com
            </span>
          </p>
          <iframe
            title="Google Maps Location"
            src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d114025.265131475!2d77.80404055470929!3d12.664099970470385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sRayakotta%20Road%2C%20Onnalvadi%2C%20Hosur%2C%20Tamil%20Nadu%20635117!5e1!3m2!1sen!2sin!4v1733598765390!5m2!1sen!2sin"
            className="google-map"
          ></iframe>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/industry-products/Crushers and Mining">Crushers and Mining</Link></li>
            {/* <li><Link to="/industry-products/Steel and Iron Manufacturing">Steel and Iron Manufacturing</Link></li> */}
            <li><Link to="/industry-products/Rubber">Rubber</Link></li>
            <li><Link to="/industry-products/Logistics and Transportation">Logistics and Transportation</Link></li>
            <li><Link to="/industry-products/Cold Storage Plants">Cold Storage Plants</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Customer Support</h3>
          <button
            className="support-button"
            onClick={() => handlePhoneClick("+91 9342943399")}
          >
            Call Support
          </button>
        </div>
      </div>

      <div className="footer-bottom">
      <div className="footer-logo">
        <img className="foot-logo" src={logo} alt="Company Team" />
        <img className="foot-text" src={text} alt="Company Team" />
      </div>
        <div className="footer-bottom-links">
          <Link to="/notices/privacycenter">Privacy Center</Link>
          <Link to="/notices/termsandconditions">Terms & Conditions</Link>
          <Link to="/notices/privacypolicy">Privacy Policy</Link>
        </div>
      </div>
      <div className="footer-bottom-text">
        {`© Copyright ${new Date().getFullYear()} SouthZone Industrial Lubricants. All Rights Reserved.`}
      </div>
    </footer>
  );
};

export default Footer;
